// AuthLayout.jsx
import React from "react";
import "antd/dist/reset.css";
import "../styles/authlayout.css"; // create this CSS file for custom styles
import imageUrl from "../assets/hero.webp"; // replace with your path

export default function AuthLayout({
  children,
  imageOnRight = true, // set false for Register-left/Login-right swap
}) {
  return (
    <section className="auth-shell">
      {/* Image side */}
      <div
        className={`auth-image auth-shell`}
        style={{ backgroundImage: `url(${imageUrl})` }}
        aria-hidden="true"
      >
<div className="row m-0 p-0 h-100">
        <div  className={`col-md-6 ${imageOnRight ? "d-none" : ""}`} style={{height:"100dvh"}}></div>
        <div className="auth-glass col-md-6 " style={{height:"100dvh"}}>
             
        <div className="auth-inner">{children}</div>
     
        </div>
        <div  className={`col-md-6 ${imageOnRight ? "" : "d-none"}`} style={{height:"100dvh"}}></div>
         
</div>
      {/* Glass panel */}
   
</div>
      <style>{css}</style>
    </section>
  );
}

const css = `

`;
